import Model from 'models/Model';
import Product from '../product/Model.Product';
import ProviderLogo from '../providerLogo/Model.ProviderLogo';
import providerDeleteApi from './delete/Api.Provider.Delete';
import providerFindApi from './find/Api.Provider.Find';
import providerListApi from './list/Api.Provider.List';
import providerSaveApi from './save/Api.Provider.Save';
import { combineStrings } from 'assets/utils/data/String';

export default class Provider
  extends Model<Model.IProvider>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProvider>
{
  id: number;
  code: string;
  name: string;
  amount: number;
  currency: string;
  streetAddress?: string;
  city?: string;
  provinceCode?: string;
  countryCode?: string;
  postalCode?: string;
  logo: ProviderLogo;
  products: Product[];

  constructor(data: Partial<Model.IProvider> | Utils.FormData<Model.IProvider>, language?: Locale.Languages) {
    super(
      {
        logo: ProviderLogo,
        products: [Product],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name || this.id?.toString(),
    };
  }
  get fullAddress() {
    return combineStrings(', ', this.streetAddress, combineStrings(' ', this.postalCode, this.provinceCode));
  }

  static async list(body?: Api.Core.Provider.List.IRequest) {
    const { payload, ...rest } = await providerListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new Provider(it)),
        count: payload.count,
      },
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await providerFindApi(params);
    return {
      ...rest,
      payload: payload ? new Provider(payload) : null,
    };
  }
  async save() {
    return await providerSaveApi(this);
  }
  async delete() {
    return await providerDeleteApi(this.id);
  }
}
